import { z } from "zod";
/**
 * Marks a branch point in the project's history tree (spec §6.2). This is a
 * navigation marker, not a musical fact — `category: "operational"`, so the
 * reducer ignores it (`reduceAll` filters operationals) and the `AudioState`
 * is unchanged. The history projection (`GET /songs/:id/history`) cross-references
 * these markers with `globalSeq` to associate events with branches.
 *
 * The log itself never branches physically: `fromEventId` is the event the
 * branch conceptually departs from; the marker is still appended to the single,
 * linear, hash-chained log like any other event.
 */
export const historyBranchCreatedPayloadSchema = z.object({
    branchId: z.string().min(1),
    fromEventId: z.string().min(1),
    label: z.string().min(1),
});
//# sourceMappingURL=history.js.map